import { councilDeviceApi } from "@/lib/api"
import { useInfiniteQuery } from "@tanstack/react-query"
import type {
  PlatformMeterInfoDTO,
  ApiResponsePaginatedResponseDTOPlatformMeterInfoDTO,
} from "@/gen/api"

type PlatformDevice = PlatformMeterInfoDTO

const platformDevicesApi = async (
  councilId: string,
  page: number,
  search?: string,
  sort?: Array<string>,
): Promise<{ devices: PlatformDevice[]; nextPage: number | null }> => {
  const response = await councilDeviceApi.getDevicePlatforms(councilId, search, page, 10, sort)
  const data = (response.data as ApiResponsePaginatedResponseDTOPlatformMeterInfoDTO).data
  return {
    devices: data?.items ?? [],
    nextPage:
      (data?.currentPage ?? -1) < (data?.totalPages ?? 0) - 1 ? (data?.currentPage ?? 0) + 1 : null,
  }
}

export const useGetPlatformDevices = (councilId: string, search?: string, sort?: Array<string>) => {
  return useInfiniteQuery<{
    devices: PlatformDevice[]
    nextPage: number | null
  }>({
    queryKey: ["platform-devices", councilId, search, sort],
    queryFn: ({ pageParam }) => platformDevicesApi(councilId, pageParam as number, search, sort),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => lastPage.nextPage,
  })
}
